const columns = [{
    title: 'Nome',
    searchName: "nome",
    dataIndex: 'name',
    key: 'name',
    width: '20%',
    sortKind: "string"
}, {
    title: 'Link',
    searchName: "link",
    dataIndex: 'link',
    key: 'link',
    width: '45%',
    sortKind: "string"
},{
    title: 'Filial',
    searchName: "filial",
    dataIndex: 'branch',
    key: 'branch',
    width: '20%'
},{
    title: 'Ação',
    dataIndex: 'uf',
    key: 'action',
    width: '15%'
}];

export default columns;


// WEBPACK FOOTER //
// ./src/const/columns/rooms.js